import { css } from '@emotion/core';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import { GridConfig } from '../../../../styles/Grid/GridSizes';

export const contentTabItemCss = css({
  display: 'none',
  '&[data-active="true"]': {
    display: 'block',
  },
});

export const contentHeadlineCss = css(typography.effra34, {
  [MediaQueries.sm]: {
    fontSize: 34,
  },
  fontWeight: fontWeights.medium,
  marginBottom: 32,
  [MediaQueries.lgAndUp]: {
    marginBottom: 24,
  },
});

export const contentDescriptionCss = css(typography.effra18, {
  marginBottom: 24,
  [MediaQueries.lgAndUp]: {
    marginBottom: 40,
  },
});

export const contentListCss = css({
  marginBottom: 44,
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 24,
  },
});

export const iconContainerCss = css({
  flex: '0 0 auto',
  height: 18,
  marginTop: 3,
  width: 18,
});

export const previewImageStyleIcon = css({
  width: '100%',
  height: '100%',
  img: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
});

export const itemContentCss = css({
  display: 'flex',
  width: '100%',
  marginBottom: 24,
  [MediaQueries.lgAndUp]: {
    width: '50%',
  },
  [MediaQueries.lg]: {
    '&:nth-of-type(even)': {
      paddingLeft: `${GridConfig.lg.gutter / 2}px`,
    },
  },
  [MediaQueries.xl]: {
    '&:nth-of-type(even)': {
      paddingLeft: `${GridConfig.xl.gutter / 2}px`,
    },
  },
});

export const itemTextContentCss = css(typography.effra16, {
  marginLeft: 27,
  color: colorsPalette.grey60,
});

export const iconCss = css({
  fontSize: 7,
  marginLeft: 8,
  marginTop: 32,
  color: colorsPalette.grey60,
});

export const viewMoreCss = css({
  cursor: 'pointer',
});

export const viewMoreTextCss = css(typography.effra12Link, {
  position: 'relative',
  color: colorsPalette.grey60,
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-2px',
    width: '100%',
    left: 0,
    height: 1,
    borderBottom: `1px solid ${colorsPalette.grey20}`,
  },
});
